import React from 'react'
import "./Getstarted.css"

const Getstarted = () => {
  return (
    <>
    <div className='getstarted-wrapper'>
      <div className='getstarted-container'>
        <p className='are-you-ready'>ARE YOU READY?</p>
        <div className='big-thing'>
          <p>Be a Part Of<br />
          The Next Big Thing
          </p>
        </div>
        <button className='btn-getstarted'>Get started</button>
      </div>
      </div>
    </>
  )
}

export default Getstarted